import React from 'react'

function Footer() {
  return (
    <div>
        <div className='group-container bg-[#282c34] min-h-[200px]'>
            <div className='flex flex-col lg:flex-row w-full'>
                <div className='w-full lg:w-1/4 text-white justify-center text-center p-4 '>
                    <div>
                        <img className='w-auto h-[100px]' src="./assets/img/logoRacolW.png" alt="logo blanco racol" />
                    </div>
                    <div className='flex items-center text-center justify-center text-red-500 font-bold text-[16px]'>
                        <i className="material-icons-outlined md-18">email</i>&nbsp;servicios@racolcomputers.com
                    </div>
                </div>
                <div className='w-full lg:w-2/4 justify-center text-center flex items-center'>
                    <div className='w-max flex flex-col md:flex-row lg:flex-col md:space-x-8 lg:space-x-0 md:pb-4'>
                        <div className=' text-white flex flex-row '>
                            <div className='flex mr-4 items-center'>
                                <i className="material-icons-outlined md-36 text-red-500">location_on</i>
                            </div>
                            <div className='md:text-[16px]'>
                                <div className='text-left font-bold text-red-500'>Santiago, Rep. Dom.</div>
                                <div className='text-left font-bold '>Av. 27 de Febrero #37, Villa Progreso</div>
                            </div>
                        </div>
                        <div className='mt-3     text-white flex flex-row pb-4 md:pb-0'>
                            <div className='mr-4 items-center flex'>
                                <i className="material-icons-outlined md-36 text-red-500">phone</i>
                            </div>
                            <div>
                                <div className='text-left font-bold text-red-500'>Llamanos!</div>
                                <div className='md:text-[16px] text-left font-bold'>(809)-971-3157</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='w-full md:w-1/4 text-white flex flex-row items-center justify-center'>
                    {/* <div className='mr-4'>
                        <i className="material-icons-outlined md-36 text-red-500">location_on</i>
                    </div>
                    <div className=''>
                        <div className='text-left font-bold text-[24px]'>(809)-971-3157</div>
                        <div className='text-left font-bold '>Llamanos!</div>
                    </div> */}
                </div>
            </div>
        </div>
        <div className='group-container bg-black min-h-[40px] text-center text-white'>
            <p>{new Date().getFullYear()} &copy; Developed by Brian Almengo</p>
        </div>
    </div>
  );
}

export default Footer;